import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Preferências de notificação desktop por atendente.
 * Persiste em localStorage — cada navegador/dispositivo tem suas próprias prefs.
 */
export interface NotificationPrefs {
  /** Inbound criando ticket pending (cliente novo na fila). */
  newTicketPending: boolean;
  /** Inbound criando ticket que já entrou como ativo (raro — fluxo de bot). */
  newTicketActive: boolean;
  /** Mensagem nova em ticket que JÁ está active (atendente responsável). */
  newMessageActive: boolean;
  /** Mensagem nova em ticket pending (segunda+ msg do cliente esperando). */
  newMessagePending: boolean;
  /** Habilita/desabilita som ao notificar. */
  soundEnabled: boolean;
}

interface NotificationStore extends NotificationPrefs {
  setPref: <K extends keyof NotificationPrefs>(key: K, value: NotificationPrefs[K]) => void;
}

const DEFAULT_PREFS: NotificationPrefs = {
  newTicketPending: true,
  newTicketActive: true,
  newMessageActive: true,
  newMessagePending: true,
  soundEnabled: true,
};

export const useNotificationPrefs = create<NotificationStore>()(
  persist(
    (set) => ({
      ...DEFAULT_PREFS,
      setPref: (key, value) => set({ [key]: value } as Partial<NotificationStore>),
    }),
    {
      name: 'chatplus-notification-prefs',
      version: 1,
    },
  ),
);
